import { InfoSection } from './InfoSection'

export default InfoSection
